import { useEffect, useState } from "react";
import { CloudArrowUp } from "@phosphor-icons/react";
import { subscribe } from "../lib/offlineQueue";

/**
 * Small pill that appears when there are queued offline scores still to be sent.
 * Disappears automatically once the queue drains.
 */
export default function SyncStatusBanner() {
  const [pending, setPending] = useState(0);

  useEffect(() => {
    const unsub = subscribe(setPending);
    return () => { unsub(); };
  }, []);

  if (pending <= 0) return null;

  return (
    <div
      data-testid="sync-status-banner"
      className="fixed top-0 left-0 right-0 z-[54] pointer-events-none"
      style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
    >
      <div className="max-w-md mx-auto px-3 pt-2 pointer-events-auto">
        <div
          className="flex items-center gap-2 rounded-xl px-3 py-2 text-xs font-semibold font-heading uppercase tracking-wide shadow-md"
          style={{ background: "#143D2F", color: "#F2EEE7" }}
        >
          <CloudArrowUp size={16} weight="bold" className="animate-pulse" />
          <span data-testid="sync-pending-count">{pending} score{pending === 1 ? "" : "s"} syncing…</span>
        </div>
      </div>
    </div>
  );
}
